import { LegalDocumentPage } from "../components/LegalDocumentPage";

/** The text lives in Firestore (`legal_documents/terms_of_service`); see LegalDocumentPage. */
export function TermsOfService() {
  return <LegalDocumentPage documentId="terms_of_service" />;
}
